import { Component, Input, OnInit } from '@angular/core';
import { cloneDeep, orderBy } from 'lodash';

import { environment } from '../../../../environments/environment';
import { ApprovalStatusEnum } from './enum/generate-approval-workflow.enum';
import { ApprovalStepsModel } from './model/generate-approval-workflow.model';

@Component({
  selector: 'app-generate-approval-workflow',
  templateUrl: './generate-approval-workflow.component.html',
  styleUrls: ['./generate-approval-workflow.component.scss']
})
export class GenerateApprovalWorkflowComponent implements OnInit {
  @Input() approvalSteps: ApprovalStepsModel[];
  public isFlowComplete = false;
  public approvalStatusEnum = ApprovalStatusEnum;
  public dateTimeDisplay = environment.dateTimeDisplay;

  constructor() {
    // intentionally empty
  }

  ngOnInit(): void {
    if (
      this.approvalSteps &&
      this.approvalSteps.length &&
      this.approvalSteps[this.approvalSteps.length - 1].approvalStatus === ApprovalStatusEnum.APPROVED
    ) {
      this.isFlowComplete = true;
    }

    this.approvalSteps = cloneDeep(this.approvalSteps);
    this.approvalSteps = this.approvalSteps.map(val => {
      if (val.approvers && val.approvers.length) {
        val.approvers = orderBy(val.approvers, ['approve'], ['asc']);
      }

      return val;
    });
  }

  getApproveOrRejectDate(step: ApprovalStepsModel): string {
    let date = null;
    if (ApprovalStatusEnum.APPROVED === step.approvalStatus) {
      date = step.approvedAt;
    } else if (ApprovalStatusEnum.REJECTED === step.approvalStatus) {
      date = step.rejectedAt;
    }

    return date;
  }

  checkAutoApprove(approvalStep: ApprovalStepsModel, approvalStatusEnum): string {
    if (approvalStep.approvalStatus === approvalStatusEnum.APPROVED && approvalStep.autoApprove) {
      return 'Auto';
    }

    return null;
  }
}
